export default "__VITE_ASSET__MWcAZV7V__"